import { Box, Stack, Typography } from '@mui/material';

export function BrandLockup({ compact = false }: { compact?: boolean }) {
  return (
    <Stack direction="row" spacing={compact ? 1 : 1.5} sx={{ alignItems: 'center', minWidth: 0 }}>
      <Box
        alt="Hesedra"
        component="img"
        src="/hesedra-logo-white.png"
        sx={{
          display: 'block',
          height: compact ? 28 : 38,
          objectFit: 'contain',
          width: 'auto',
        }}
      />
      <Typography
        aria-label="Go-Live"
        sx={{
          borderLeft: '1px solid rgba(255, 255, 255, 0.45)',
          color: 'common.white',
          fontFamily: 'inherit',
          fontSize: compact ? '0.68rem' : '0.76rem',
          fontWeight: 800,
          letterSpacing: '0.14em',
          lineHeight: 1.2,
          pl: compact ? 1 : 1.5,
          whiteSpace: 'nowrap',
        }}
      >
        GO-LIVE
      </Typography>
    </Stack>
  );
}
